import React, { createContext, PropsWithChildren } from "react"
import { AspectRatio, Box, Modal, ModalContent, ModalOverlay, useDisclosure } from "@chakra-ui/react"
import Image from "@app/components/Image/Image"
import ReactPlayer from "react-player/youtube"
import VideoPlayButton from "./VideoPlayButton"

export interface VideoProps extends PropsWithChildren {
  video: NormalisedVideo
  handleTrackingClick?: VoidFunction
}

export const VideoContext = createContext<Omit<VideoProps, "children">>({
  video: {} as NormalisedVideo,
  handleTrackingClick: undefined,
})

const Video = ({ video, children, handleTrackingClick }: VideoProps) => (
  <VideoContext.Provider value={{ video, handleTrackingClick }}>
    <Box borderRadius={"10px"} overflow={"hidden"} mb={2}>
      <AspectRatio ratio={648 / 366} w="full" h="full">
        <ReactPlayer
          url={video.videoUrl || ""}
          onClick={handleTrackingClick}
          playing
          playIcon={<VideoPlayButton />}
          light={video.poster?.src}
          height={"100%"}
          width={"100%"}
        />
      </AspectRatio>
    </Box>
    {children}
  </VideoContext.Provider>
)

export default React.memo(Video)

export const VideoItem = ({ video, children, handleTrackingClick }: VideoProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { srcSet, src, dimension, alt } = video.poster

  return (
    <VideoContext.Provider value={{ video, handleTrackingClick }}>
      <Box onClick={onOpen}>
        <Box borderRadius={"10px"} mb={2} pos={"relative"} cursor={"pointer"}>
          <AspectRatio ratio={648 / 366} w="full" h="full">
            <Image src={src} srcSet={srcSet} sizes={dimension} alt={alt} backgroundColor={`white`} overflow={`hidden`} />
          </AspectRatio>
          <VideoPlayButton />
        </Box>
        {children}
      </Box>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent maxW={["100%", "60%"]} borderRadius={0} backgroundColor={"black"}>
          <AspectRatio ratio={648 / 366} w="full" h="full">
            <ReactPlayer
              muted
              url={video.videoUrl || ""}
              onClick={handleTrackingClick}
              playing
              controls
              // playIcon={<VideoPlayButton />}
              light={video.poster?.src}
              height={"100%"}
              width={"100%"}
            />
          </AspectRatio>
        </ModalContent>
      </Modal>
    </VideoContext.Provider>
  )
}
